import axios from "axios";
import APIModel from "../../Models/APIModel";

export const getSites = (token) => {
  return axios.get(APIModel.HOST + "Admin/GetSites",{
    'headers': {
      'Content-Type': 'application/json',
      'Accept':'application/json',
      'token':token
    }
  });
};

export const createSite = (token,params) => {
  return axios.post(APIModel.HOST + "Admin/CreateSite",params,{
    'headers': {
      'Content-Type': 'application/json',
      'Accept':'application/json',
      'token':token
    }
  });
};


// export const changeSiteData = (token,siteId) => {
//   return axios.post(APIModel.HOST + "User/ChangeSite",siteId,{
//     'headers': {
//       'Content-Type': 'application/json',
//       'Accept':'application/json',
//       'token':token
//     }
//   });
// };

export const editSite = (token,params) => {
  return axios.post(APIModel.HOST + "Admin/EditSite",params,{
    'headers': {
      'Content-Type': 'application/json',
      'Accept':'application/json',
      'token':token
    }
  });
};
